import { render } from "./Race.vue?vue&type=template&id=6200df64&scoped=true"
import script from "./Race.vue?vue&type=script&lang=js"
export * from "./Race.vue?vue&type=script&lang=js"

import "./Race.vue?vue&type=style&index=0&id=6200df64&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6200df64"]])

export default __exports__